import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "../Popup/Popup";
import { JQModal } from "../Popup/Utils";
import { ENocMApplication, EnocMollakDocuments } from "../../enocapi/entities";
import { LocaleUtil } from "@eres/core";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { getToken } from "@my-dld/utils/User";

interface Props {
	selectedRequest: ENocMApplication;
	onDocumentSelect?: () => void;
	onClose: () => void;
}

class RemarkPopup extends Component<Props> {
	render() {
		const { selectedRequest } = this.props;
		return (
			<Popup
				autoOpenMount={ true } showIcon={ false } id={ "RemarkPopup" } onDismiss={ () => {
				JQModal( "RemarkPopup" ).hide();
				this.props.onClose();
			} }>
				<div className="alert alert-info">{ "# " + selectedRequest.requestNumber }</div>
				<div className="flex-grid flex-grid-modal mb-0">
					<div>
						<span>{ Strings.eligibility_status }</span>
						<span>{ LocaleUtil.getLocalValue( selectedRequest.eligibility ) }</span>
					</div>
					<div>
						<span>{ Strings.remarks }</span>
						<span>{ selectedRequest.remarks }</span>
					</div>
					<div>
						<span>{ Strings.documents }</span>
						<span className="flex-grid-pdf">
                            {
	                            selectedRequest.documents?.map( ( value: EnocMollakDocuments, index: number ) => {
		                            let fileUrl = value.url!;
		                            let fileName = LocaleUtil.getLocalValue( value.documentCategory );
		                            return <a
			                            key={ `enoc_req_doc_${ index }` }
			                            onClick={ () => {
				                            window.open( fileUrl );
			                            } }>
			                            <i className="icon-pdf-o"/>{ fileName }</a>;
	                            } )
                            }
                        </span>
					</div>
				</div>
			</Popup>
		);
	}
}

export default RemarkPopup;

function getImagePreview( enocDoc: EnocMollakDocuments ) {
	let source = ( enocDoc.url && !isEmptyStringOrNull( enocDoc.url ) ) ?
		enocDoc.url : undefined;
	return <img src={ source } style={ { height: 40, width: 40 } } alt={ "uploaded_image" }/>;
}

function downloadFile( pdfURL?: string ) {
	if ( pdfURL ) {
		showLoading();
		var params = {
			token: getToken() ?? "",
		};

		fetch( pdfURL, { headers: params } ).then( r => r.blob() )
		.then( blob => {
			let newBlob = new Blob( [ blob ], { type: "application/pdf" } );
			let url = window.URL.createObjectURL( newBlob );
			let a = document.createElement( "a" );
			a.href = url;
			a.download = pdfURL;
			a.click();
			hideLoading();
		} ).catch( e => hideLoading() );
	}

}

/*
 return <li key={ `enoc_req_doc_${ index }` }
                                                           className="d-flex justify-content-between align-items-center"
                                                           onClick={ () => {
                                                              window.open(fileUrl)
                                                           } }>
                                                    <a><i className="icon-pdf-o"></i>{fileName}</a></li>
 */
